module.exports = __webpack_public_path__ + "static/media/about-bg.2ed6d556.jpg";